import { ICreateEngineFiscalRulesState } from "@/@types/engine-fiscal-rules";
import { useDispatch } from "react-redux";
import { addItem, clearList, removeItem } from "..";

export const useFiscalRulesListActions = () => {
  const dispatch = useDispatch();

  const addFiscalRule = (item: ICreateEngineFiscalRulesState) => {
    dispatch(addItem(item));
  };

  const removeFiscalRule = (item: ICreateEngineFiscalRulesState) => {
    dispatch(removeItem(item));
  };

  const clearFiscalRulesList = () => {
    dispatch(clearList());
  };

  return {
    addFiscalRule,
    removeFiscalRule,
    clearFiscalRulesList,
  };
};

export const useIcmsListActions = useFiscalRulesListActions;
